import React, { useEffect } from 'react';

const typeStyles = {
  success: {
    header: 'text-green-300',
    icon: '✅',
    border: 'border-green-600'
  },
  error: {
    header: 'text-red-300',
    icon: '⚠️',
    border: 'border-red-600'
  },
  info: {
    header: 'text-blue-300',
    icon: 'ℹ️',
    border: 'border-blue-600'
  }
};

const NoticeModal = ({ open, type = 'info', title, message, onClose, autoCloseMs = 0 }) => {
  useEffect(() => {
    if (!open || !autoCloseMs) return;
    const t = setTimeout(() => onClose && onClose(), autoCloseMs);
    return () => clearTimeout(t);
  }, [open, autoCloseMs, onClose]);

  if (!open) return null;

  const styles = typeStyles[type] || typeStyles.info;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className={`bg-dark-800 border ${styles.border} rounded-xl p-6 max-w-md w-full shadow-xl`}>
        <div className="flex items-start gap-3">
          <div className="text-2xl" aria-hidden>{styles.icon}</div>
          <div className="flex-1">
            {title && <h3 className={`text-lg font-semibold mb-2 ${styles.header}`}>{title}</h3>}
            {message && <p className="text-dark-200 text-sm leading-relaxed">{message}</p>}
          </div>
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="bg-primary-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-primary-700 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeModal;


